import UserAccessManagement, { RoleMap } from "components/UserAccessManagement/UserAccessManagement";
import { LoaderInline } from "imaginarity-react-ui";
import * as React from "react";
import { PlaylistEditSequenceLinearSC as T } from './PlaylistEditSequenceLinearSC';
import { usePLEState } from "./usePLEState";

type PlaylistEditAccessProps = {
    roles: RoleMap | undefined;
    setRoles: React.Dispatch<React.SetStateAction<RoleMap | undefined>>;
};

const PlaylistEditAccess = (p: PlaylistEditAccessProps) => {
    const { roles, setRoles } = p;
    const { value } = usePLEState(x => x.group_id);

    const [loaded, setLoaded] = React.useState(false);
    return (
        <T.PEAContainer>
            <T.ImplContainerInfo>
            </T.ImplContainerInfo>
            <LoaderInline active={!loaded || roles === undefined} />
            <UserAccessManagement
                groupId={value}
                roles={roles ?? []}
                setRoles={setRoles as React.Dispatch<React.SetStateAction<RoleMap>>}
                onAllRolesLoaded={() => setLoaded(true)}
                namespace="playlist"
            />
        </T.PEAContainer>

    )
}

export default PlaylistEditAccess;